module.exports = __webpack_public_path__ + "img/payment-cash.21f8287.svg";